import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de59257c360032/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/dist/client/link.js");
